<app-dialog
  id="fileUpload"
  [title]="'fileUpload.title' | translate"
  [confirmation]="'button.upload' | translate"
  [isValid]="uploadValid"
  (save)="sendFile()"
>
  <mat-progress-bar mode="indeterminate" *ngIf="isLoadingData"> </mat-progress-bar>

  <ng-container *ngIf="displayImageUpload; else documentUpload">
    <div>
      <img id="preview" src="assets/images/img-thumbnail.svg" width="100%" height="100%" class="uploaded-image" />
      <input
        #upload
        hidden="true"
        type="file"
        onclick="this.value=null"
        (change)="previewFile($event)"
        track="Account-Settings, document_upload"
        accept="image/jpg, image/jpeg, image/png"
      />
    </div>

    <div class="browse">
      <button mat-flat-button color="primary" (click)="upload.click()">
        {{ 'fileUpload.browse' | translate }}
      </button>
    </div>

    <ul>
      <li id="sizeValid">
        {{ 'fileUpload.sizeCondition' | translate }}
      </li>
      <li id="typeValid">
        {{ 'fileUpload.imageFileType' | translate }}
      </li>
      <ng-container *ngIf="warning && uploadValid">
        <li class="warn">
          {{ 'fileUpload.uploadFileWarning' | translate }}
        </li>
      </ng-container>
    </ul>
  </ng-container>
  <ng-template #documentUpload>
    <div class="d-flex">
      <input
        #upload
        hidden="true"
        type="file"
        onclick="this.value=null"
        (change)="previewFile($event)"
        track="Account-Settings, document_upload"
        [accept]="this.isVideo ? 'video/mp4' : 'application/pdf, text/plain'"
      />

      <ng-container *ngIf="uploadValid; else invalidFile">
        <mat-icon>file_copy</mat-icon>
        <p>{{ fileName }}</p>
      </ng-container>
      <ng-template #invalidFile>
        <p>{{ fileName }}</p>
      </ng-template>
    </div>

    <div class="browse">
      <button mat-flat-button color="primary" (click)="upload.click()">
        {{ 'fileUpload.browse' | translate }}
      </button>
    </div>

    <ul>
      <li id="sizeValid">
        {{ this.isVideo ? ('fileUpload.sizeConditionVideo' | translate) : ('fileUpload.sizeCondition' | translate) }}
      </li>
      <li id="typeValid">
        {{ this.isVideo ? ('fileUpload.documentVideoType' | translate) : ('fileUpload.documentFileType' | translate) }}
      </li>
      <ng-container *ngIf="warning && uploadValid">
        <li class="warn">
          {{ 'fileUpload.uploadDocumentWarning' | translate }}
        </li>
      </ng-container>
    </ul>
  </ng-template>
</app-dialog>
